export const EnvironmentChipColors = {
    local: 'rgb(232,64,196)',
    test: 'rgb(77,163,9)',
    uat: 'rgb(31,114,211)',
    hotfix: 'rgb(235,133,14)',
    font: 'rgb(255,255,255)',
};
